import React from 'react'

// Lightweight corner badge to indicate a page is under maintenance.
// Inline styles keep this drop-in friendly for quick reuse.
const MaintenanceBadge = ({ children = 'Under Maintenance', style = {} }) => {
  const base = {
    position: 'fixed',
    right: 12,
    bottom: 12,
    background: 'rgba(255,165,0,0.95)',
    color: '#111',
    padding: '6px 10px',
    borderRadius: 6,
    boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
    fontSize: 12,
    zIndex: 2000,
    cursor: 'default',
    userSelect: 'none',
    ...style,
  }

  return (
    <div style={base} role="status" aria-live="polite">
      {children}
    </div>
  )
}

export default MaintenanceBadge
